import React from 'react';
import { formatDecimal, formatPercent, formatPosition } from '../format';

// Emphasis bar chart: the client in the accent colour, competitors in gray.
// Bars are scaled to the total number of answers, so a full bar = 100 %.
const CompetitorChart = ({ report }) => {
  const { business, summary, competitors } = report;
  const total = summary.answersAnalyzed;

  const rows = [
    ...competitors.map((c) => ({ ...c, isYou: false })),
    {
      name: business.name,
      appearances: summary.appearances,
      bestPosition: summary.bestPosition,
      isYou: true
    }
  ].sort((a, b) => b.appearances - a.appearances || Number(a.isYou) - Number(b.isYou));

  return (
    <div>
      <ol className="space-y-5" aria-label={`Porcentaje de las ${total} respuestas en que aparece cada negocio`}>
        {rows.map((row) => {
          const share = formatPercent(row.appearances, total);
          const width = Math.max((row.appearances / total) * 100, 0.6);
          const labelInside = width > 85;
          const detail = row.isYou
            ? `${row.appearances} de ${total} respuestas · mejor puesto ${formatPosition(row.bestPosition)}`
            : `${row.appearances} de ${total} respuestas · puesto medio ${formatDecimal(row.avgPosition)}`;

          return (
            <li
              key={row.name}
              tabIndex={0}
              aria-label={`${row.isYou ? 'Tú, ' : ''}${row.name}: ${share}. ${detail}.`}
              className="rp-bar-row rp-keep relative grid items-center gap-x-6 gap-y-2 sm:grid-cols-[minmax(0,15rem)_1fr]"
            >
              <span className="flex items-baseline gap-2 font-semibold">
                <span className="truncate">{row.name}</span>
                {row.isYou && (
                  <span className="lp-mono shrink-0 text-[11px] font-normal uppercase tracking-[0.14em] text-[var(--lp-muted)]">
                    Tú
                  </span>
                )}
              </span>
              {/* Value sits at the bar's tip; inside the bar only when it wouldn't fit after it. */}
              <span className="relative block h-[18px]">
                <span
                  className={`rp-bar absolute inset-y-0 left-0 ${row.isYou ? 'rp-bar--you' : ''}`}
                  style={{ width: `${width}%` }}
                />
                <span
                  className={`absolute top-1/2 -translate-y-1/2 whitespace-nowrap text-sm font-semibold ${
                    labelInside ? (row.isYou ? 'rp-bar-label-in--you' : 'rp-bar-label-in') : ''
                  }`}
                  style={labelInside ? { right: `calc(${100 - width}% + 8px)` } : { left: `calc(${width}% + 10px)` }}
                >
                  {share}
                </span>
              </span>

              <span
                aria-hidden="true"
                className="rp-tooltip absolute -top-9 right-0 z-10 whitespace-nowrap rounded-lg border border-[var(--lp-line)] bg-[var(--lp-surface)] px-3 py-1.5 text-xs text-[var(--lp-text)]"
              >
                {detail}
              </span>
            </li>
          );
        })}
      </ol>
      <p className="mt-6 text-sm text-[var(--lp-muted)]">
        Porcentaje de las {total} respuestas de la IA en las que aparece cada negocio.
      </p>
    </div>
  );
};

export default CompetitorChart;
